import { useStudentActivitiesQuery } from "@generated/graphql"
import { ActivitySliderWrapper } from "../styled/Activity"
import ActivityCardItem from "./ActivityCardItem"

interface IRelativeActivities {
  skillSlug: string
}

export default function RelativeActivities({ skillSlug }: IRelativeActivities) {

  const settings = {
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 625,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const { data: activitiesData } = useStudentActivitiesQuery({
    variables: {
      where: {
        skill: {
          slug: skillSlug,
        }
      },
      take: 3,
      skip: 0
    }
  })

  return (
    <ActivitySliderWrapper {...settings}>
      {activitiesData?.studentActivities.map((activity) => <ActivityCardItem showButton="play" key={activity.id} item={activity} />)}
    </ActivitySliderWrapper>
  )
}
